export const icon_cooler = require('./icon-cooler.png')
export const icon_fans = require('./icon-fans.png')
export const icon_heater = require('./icon-heater.png')
export const icon_defroster = require('./icon-defroster.png')
export const screensaverMp4 = require('./screensaver.mp4')
export const icon_running = require('./icon-running.gif')
export const icon_menu_recipe = require('./icon-menu-recipe.png')
